import { StaffDirectoryTable } from "@/components/staff-directory/staff-directory-table";
import { createFileRoute } from "@tanstack/react-router";

function StaffDirectoryPage() {
  return <StaffDirectoryTable />;
}

export const Route = createFileRoute(
  "/_authenticated/website/staff-directory/",
)({
  component: StaffDirectoryPage,
});
